<template>
  <div>
    <el-dialog :title="manageData.title" :visible.sync="manageData.show" width="1000px" center>
      <div class="manage-box">
        <div class="left">
          <div style="margin-bottom:10px;">
            <span style="margin-right:10px;">当前代理:</span>
            <span style="color:red;margin-right:20px;">213123122</span>
            <span>线下共有</span>
            <span style="color:red;">1234</span>
            <span>人</span>
          </div>
          <el-form inline :model="queryForm">
            <el-form-item :label="$t('playerID')">
              <el-input v-model="queryForm.UserId" :placeholder="$t('Please.enter.each.ID')" style="width: 150px" clearable></el-input>
            </el-form-item>
            <el-form-item label="玩家级别">
              <el-select v-model="queryForm.SellerId" placeholder="玩家级别" style="width: 150px" clearable>
                <el-option label="1" value="1"> </el-option>
                <el-option label="2" value="2"> </el-option>
                <el-option label="3" value="3"> </el-option>
                <el-option label="4" value="4"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary">{{$t('Search')}}</el-button>
            </el-form-item>
          </el-form>
          <el-button style="margin-bottom:10px;" type="primary">级别标记</el-button>
          <el-table :data="tableData" style="width: 100%" border :cell-style="{ padding: '1' }">
            <el-table-column prop="Id" :label="$t('playerID')"></el-table-column>
            <el-table-column prop="Id" label="玩家级别"></el-table-column>
            <el-table-column prop="Id" :label="$t('PlayerAccountBalance')"></el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total" @current-change="handleCurrentChange" :page-size="pagesize" :page-sizes="pagesizes" :current-page="current_row">
            </el-pagination>
          </div>
        </div>
        <div class="right">
          <div class="">级别配置：</div>
          <div class="Configuration">
            <div>线下玩家共分四个级别</div>
            <div>
              <span>1级别玩家初始额度：</span>
              <span style="color:red;">247 </span>
            </div>
            <div>
              <span>2级别玩家初始额度：</span>
              <span style="color:red;">247 </span>
            </div>
            <div>
              <span>3级别玩家初始额度：</span>
              <span style="color:red;">247 </span>
            </div>
            <div style="margin-bottom:10px;">
              <span>4级别玩家初始额度：</span>
              <span style="color:red;">247 </span>
            </div>
            <el-table :data="tableData" style="width: 100%" border :cell-style="{ padding: '1' }" @selection-change="handleSelectionChange">
              <el-table-column prop="Id" label="玩家级别"></el-table-column>
              <el-table-column prop="Id" label="初始额度"></el-table-column>
              <el-table-column prop="Id"  :label="$t('Actions')"></el-table-column>
            </el-table>
            <div style="display: flex; align-items: center;justify-content: center;margin-top:20px;">
              <el-button type="primary">增加级别</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  props: {
    manageData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      queryForm: {},
      tableData: [{}],
      multipleSelection: [],
    };
  },
  created() {
    this.app = app;
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getListData();
    },
  },
};
</script>

<style  scoped>
.manage-box {
  display: flex;
}

.right {
  flex: 1;
  margin-left: 20px;
}
.Configuration {
  border: 1px dashed #ccc;
  /* height: 100%; */
  margin-top: 10px;
  padding: 10px 20px;
  box-sizing: border-box;
}
</style>